export default function FormSelect({ label, value, options = [], onChange }) {
    const normalizeOption = (option) => {
        if (typeof option === "string") {
            return {
                key: option,
                value: option,
                label: option
            };
        }

        return {
            key: option.value ?? option.label ?? JSON.stringify(option),
            value: option.value ?? "",
            label: option.label ?? option.value ?? ""
        };
    };

    return (
        <div className="wg-field">
            <label className="wg-label">{label}</label>
            <select
                className="wg-input"
                value={value ?? ""}
                onChange={(e) => onChange(e.target.value)}
            >
                {options.map((option, index) => {
                    const item = normalizeOption(option);

                    return (
                        <option
                            key={`${item.key}-${index}`}
                            value={item.value}
                        >
                            {item.label}
                        </option>
                    );
                })}
            </select>
        </div>
    );
}